export default "__VITE_ASSET__BR1R6dGH__"